import React, { FC } from "react";
// @ts-ignore: federated module
import { useViewResolverContext } from "@ldp/view-resolver-lite";
import ProductListingPage from "./components/product-listing-page.component";
import FavouriteListingPage from "./components/favourite-listing-page.component";

/** Listing page props */
export interface IListingPageComponentProps {
  children?: React.ReactNode;
}

/**
 * Renders Listing page structure
 */
export const ListingPageComponent: FC<IListingPageComponentProps> = () => {
  const {
    // @ts-ignore: federated module
    viewDefinition: { categoryId },
  } = useViewResolverContext();

  return categoryId === "favourite" ? (
    <FavouriteListingPage />
  ) : (
    <ProductListingPage />
  );
};

export default ListingPageComponent;
